export const TOGGLE_MODAL                = 'TOGGLE_MODAL';
export const UPDATE_MODAL                = 'UPDATE_MODAL';


/*** Scripts end... */